import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantRentalRentComfirmPage } from './merchant-rental-rent-comfirm';

@NgModule({
  declarations: [
    MerchantRentalRentComfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantRentalRentComfirmPage),
    TranslateModule.forChild()
  ],
})
export class MerchantRentalRentComfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental-rent-comfirm/merchant-rental-rent-comfirm.module.ts